export default "/images/alert_white.svg"